module.exports = __webpack_public_path__ + "img/kitty3.5c6bc899.jpg";